goog.module('yext.location.Date');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');

/**
 * Custom Date Field
 *
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 * @author Alexander Zhang (azhang@yext.com)
 */
const Date = function($ctx) {
  this.$ctx = $ctx;
  this.$input = this.$ctx.find('.js-date-input');
  this.indeterminate = false;
  this.fieldName = this.$ctx.find('input[name="field"]').val();
  this.parseStateFromDOM();
  this.storeValue();
  this.bind();
  this.bindReset();

  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * Broadcast messages with the field as context
 */
Date.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the field to a stored state
 */
Date.prototype.reset = function() {
  this.set({
    date: this.storedValue.date,
    indeterminate: this.storedValue.indeterminate,
  });
};

/**
 * Render the field based upon the model state
 */
Date.prototype.render = function() {
  this.$ctx.find('.js-date-wrap').toggle(!this.indeterminate);
  this.$ctx.find('.js-indeterminate-message').toggle(this.indeterminate);
};

/**
 * Set the fields value
 *
 * @param {string} field Field data
 */
Date.prototype.set = function(field) {
  this.$input.val(field.date);
  this.indeterminate = !!field.indeterminate;

  this.render();
};

/**
 * Store the state for use in reset
 */
Date.prototype.storeValue = function() {
  this.storedValue = {
    date: this.$input.val(),
    indeterminate: this.indeterminate,
  };
};

/**
 * Bind the datepicker and update events
 * @suppress {deprecated}
 */
Date.prototype.bind = function() {
  var self = this;

  yext.time.newDatepicker(this.$input, function(date) {
    var options = {month: '2-digit', day: '2-digit', year: 'numeric'};
    self.$input.val(date
      ? date.toLocaleDateString(window.currentLanguageFallbacks, options).replace(/[ \/\.\-]+/g, '/')
      : '');
    self.indeterminate = false;
    self.message('updated');
    $(self).trigger('update.struct');
    $(self).trigger('update.list');
    self.updateAssetOrOriginal(false);
  }, {
    minDate: self.minDate,
    maxDate: self.maxDate,
    changeMonth: true,
    changeYear: true,
  });

  this.$input.focus(function() {
    self.$input.datepicker('show');
  });
};

/**
 * Get the display value for the field
 *
 * @return {string} Date string
 */
Date.prototype.getDisplayValue = function(cannotEdit) {
  if (this.indeterminate) {
    return helpers.variousContentMessage();
  } else if (this.$input.val() === '') {
    return helpers.emptyFieldMessage(cannotEdit);
  } else {
    return this.$input.val();
  }
};

/**
 * Parse the initial state from the DOM
 */
Date.prototype.parseStateFromDOM = function() {
  this.indeterminate = this.$ctx.data('indeterminate');
  this.minDate = yext.isString(this.$input.data('min')) ? this.$input.data('min') : null;
  this.maxDate = yext.isString(this.$input.data('max')) ? this.$input.data('max') : null;
};

/**
 * Bind the reset link in bulk edit case
 */
Date.prototype.bindReset = function() {
  var self = this;
  this.$ctx.find('.js-reset-date').click(function() {
    self.indeterminate = false;
    self.render();
  });
};

/**
 * Get timestamp
 *
 * @return {string} Timestamp for date field
 */
Date.prototype.getTimestamp = function() {
  return this.$ctx.find('.js-field-timestamp').val();
};


/**
 * Package relevant field info to send to a parent struct.
 */
Date.prototype.getJSONData = function() {
  return {
    [this.fieldName + '.value']: this.$input.val(),
    [this.fieldName + '.timestamp']: this.getTimestamp(),
  };
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
Date.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
Date.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$input.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
Date.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * The after save function when this date field is a child of a struct.
 */
Date.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate /* unused */, cannotEdit) {
  this.set(fieldValues);
  this.storeValue();
  $display.empty().append(this.getDisplayValue(cannotEdit));

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * clears field
 */
Date.prototype.clear = function() {
  this.set({
    date: '',
    indeterminate: false,
  });
};

exports = Date;
